import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CalendarNavigation = ({ currentYear, onYearChange, onExportPDF, onExportCSV }) => {
  const handlePreviousYear = () => {
    onYearChange(currentYear - 1);
  };

  const handleNextYear = () => {
    onYearChange(currentYear + 1);
  };

  const handleCurrentYear = () => {
    onYearChange(new Date()?.getFullYear());
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-6 shadow-sm">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={handlePreviousYear}
            iconName="ChevronLeft"
            iconPosition="left"
            aria-label="Previous year"
          >
            <span className="hidden md:inline">Previous</span>
          </Button>

          <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary/10">
            <Icon name="Calendar" size={20} className="text-primary" />
            <span className="text-lg md:text-xl font-semibold text-foreground">{currentYear}</span>
          </div>

          <Button
            variant="outline"
            size="sm"
            onClick={handleNextYear}
            iconName="ChevronRight"
            iconPosition="right"
            aria-label="Next year"
          >
            <span className="hidden md:inline">Next</span>
          </Button>

          {currentYear !== new Date()?.getFullYear() && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleCurrentYear}
              iconName="CalendarCheck"
              iconPosition="left"
            >
              Today
            </Button>
          )}
        </div>

        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={onExportPDF}
            iconName="FileDown"
            iconPosition="left"
          >
            Export PDF
          </Button>

          <Button
            variant="default"
            size="sm"
            onClick={onExportCSV}
            iconName="Download"
            iconPosition="left"
          >
            Export CSV
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarNavigation;